import common from './en-US/common';

export default {
  ...common,
};
